import React from 'react';

import bn from 'utils/bemnames';

import {
  Navbar,
  // NavbarToggler,
  Nav,
  NavItem,
  Button,
} from 'reactstrap';

import {
   FaBars,
} from 'react-icons/lib/fa';
import Usuario from 'componentes/usuario';
import Ambiente from 'componentes/Ambiente';

const bem = bn.create('header');

class Cabecalho extends React.Component {
  state = {
    isOpenUsuarioPopover: false,
  };


  toggleUsuarioPopover = () => {
    this.setState({
      isOpenUsuarioPopover: !this.state.isOpenUsuarioPopover,
    });
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.sr-sidebar').classList.toggle('sr-sidebar--open');
  };

  render() {
    return (
      <Navbar light expand className={bem.b('bg-white')}>
        <Nav navbar className="mr-2">
          <Button outline onClick={this.handleSidebarControlButton}>
            <FaBars size={37} />
          </Button>
        </Nav>
                  
        <Navbar>
            <Ambiente className="navbar-brand d-flex">
              <img
                src="/img/logo/logo_blue.png"
                width="142"
                height="81"
                className="pr-2"
                alt=""
              />

            </Ambiente>
          </Navbar>

        <Nav navbar className={bem.e('nav-right')}>

          <NavItem>
            <Usuario
              estaAberto={this.state.isOpenUsuarioPopover}
              alternarPopover={this.toggleUsuarioPopover} />
          </NavItem>
        </Nav>
      </Navbar>
    );
  }
}

export default Cabecalho;



// WEBPACK FOOTER //
// ./src/componentes/Layout/Cabecalho.js